import createIcon from '../../createIcon';

/**
 * @component @name FormatIndentDecrease
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTdIMjFWMTVIMTFWMTdaTTMgMTJMNyAxNlY4TDMgMTJaTTMgMjFIMjFWMTlIM1YyMVpNMyAzVjVIMjFWM0gzWk0xMSA5SDIxVjdIMTFWOVpNMTEgMTNIMjFWMTFIMTFWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatIndentDecrease = createIcon('FormatIndentDecrease', [
  [
    'path',
    {
      d: 'M11 17H21V15H11V17ZM3 12L7 16V8L3 12ZM3 21H21V19H3V21ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z',
      key: '12h1h9',
    },
  ],
]);

export default FormatIndentDecrease;
